/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	CreateResourceRequest,
	CreateResourceResponse,
	DeleteResourceRequest,
	EnumerateResourcesRequest,
	ReadResourceRequest,
	ReadResourceResponse,
	ResourceState,
	RestoreResourceRequest,
	RestoreResourceResponse,
	UpdateResourceRequest,
	UpdateResourceResponse,
} from '../models/index';
import {
	CreateResourceRequestFromJSON,
	CreateResourceRequestToJSON,
	CreateResourceResponseFromJSON,
	CreateResourceResponseToJSON,
	DeleteResourceRequestFromJSON,
	DeleteResourceRequestToJSON,
	EnumerateResourcesRequestFromJSON,
	EnumerateResourcesRequestToJSON,
	ReadResourceRequestFromJSON,
	ReadResourceRequestToJSON,
	ReadResourceResponseFromJSON,
	ReadResourceResponseToJSON,
	ResourceStateFromJSON,
	ResourceStateToJSON,
	RestoreResourceRequestFromJSON,
	RestoreResourceRequestToJSON,
	RestoreResourceResponseFromJSON,
	RestoreResourceResponseToJSON,
	UpdateResourceRequestFromJSON,
	UpdateResourceRequestToJSON,
	UpdateResourceResponseFromJSON,
	UpdateResourceResponseToJSON,
} from '../models/index';

export interface CreateResourceOperationRequest {
	xBffCsrf?: string;
	createResourceRequest?: CreateResourceRequest;
}

export interface DeleteResourceOperationRequest {
	xBffCsrf?: string;
	deleteResourceRequest?: DeleteResourceRequest;
}

export interface EnumerateResourcesOperationRequest {
	xBffCsrf?: string;
	enumerateResourcesRequest?: EnumerateResourcesRequest;
}

export interface ReadResourceOperationRequest {
	xBffCsrf?: string;
	readResourceRequest?: ReadResourceRequest;
}

export interface RestoreResourceOperationRequest {
	xBffCsrf?: string;
	restoreResourceRequest?: RestoreResourceRequest;
}

export interface UpdateResourceOperationRequest {
	xBffCsrf?: string;
	updateResourceRequest?: UpdateResourceRequest;
}

/**
 * PackagingApi - interface
 *
 * @export
 * @interface PackagingApiInterface
 */
export interface PackagingApiInterface {
	/**
	 * Create resource from packaging
	 * @summary Create resource from packaging
	 * @param {string} [xBffCsrf]
	 * @param {CreateResourceRequest} [createResourceRequest] Payload to create packaging resource
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof PackagingApiInterface
	 */
	createResourceRaw(
		requestParameters: CreateResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CreateResourceResponse>>;

	/**
	 * Create resource from packaging
	 * Create resource from packaging
	 */
	createResource(
		requestParameters: CreateResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CreateResourceResponse>;

	/**
	 * Delete packaging resource
	 * @summary Delete packaging resource
	 * @param {string} [xBffCsrf]
	 * @param {DeleteResourceRequest} [deleteResourceRequest] Payload to delete packaging resource
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof PackagingApiInterface
	 */
	deleteResourceRaw(
		requestParameters: DeleteResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Delete packaging resource
	 * Delete packaging resource
	 */
	deleteResource(
		requestParameters: DeleteResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Enumerate packaging resources
	 * @summary Enumerate packaging resources
	 * @param {string} [xBffCsrf]
	 * @param {EnumerateResourcesRequest} [enumerateResourcesRequest] Payload to enumerate packaging resources
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof PackagingApiInterface
	 */
	enumerateResourcesRaw(
		requestParameters: EnumerateResourcesOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<Array<ResourceState>>>;

	/**
	 * Enumerate packaging resources
	 * Enumerate packaging resources
	 */
	enumerateResources(
		requestParameters: EnumerateResourcesOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<Array<ResourceState>>;

	/**
	 * Read package resource
	 * @summary Read package resource
	 * @param {string} [xBffCsrf]
	 * @param {ReadResourceRequest} [readResourceRequest] Payload to read packaging resource
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof PackagingApiInterface
	 */
	readResourceRaw(
		requestParameters: ReadResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ReadResourceResponse>>;

	/**
	 * Read package resource
	 * Read package resource
	 */
	readResource(
		requestParameters: ReadResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ReadResourceResponse>;

	/**
	 * Restore packaging resource
	 * @summary Restore packaging resource
	 * @param {string} [xBffCsrf]
	 * @param {RestoreResourceRequest} [restoreResourceRequest] Payload to restore packaging resource
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof PackagingApiInterface
	 */
	restoreResourceRaw(
		requestParameters: RestoreResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<RestoreResourceResponse>>;

	/**
	 * Restore packaging resource
	 * Restore packaging resource
	 */
	restoreResource(
		requestParameters: RestoreResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<RestoreResourceResponse>;

	/**
	 * Update packaging resource
	 * @summary Update packaging resource
	 * @param {string} [xBffCsrf]
	 * @param {UpdateResourceRequest} [updateResourceRequest] Payload to update packaging resource
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof PackagingApiInterface
	 */
	updateResourceRaw(
		requestParameters: UpdateResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<UpdateResourceResponse>>;

	/**
	 * Update packaging resource
	 * Update packaging resource
	 */
	updateResource(
		requestParameters: UpdateResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<UpdateResourceResponse>;
}

/**
 *
 */
export class PackagingApi extends runtime.BaseAPI implements PackagingApiInterface {
	/**
	 * Create resource from packaging
	 * Create resource from packaging
	 */
	async createResourceRaw(
		requestParameters: CreateResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CreateResourceResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration/packaging/createResource`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: CreateResourceRequestToJSON(requestParameters.createResourceRequest),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			CreateResourceResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Create resource from packaging
	 * Create resource from packaging
	 */
	async createResource(
		requestParameters: CreateResourceOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CreateResourceResponse> {
		const response = await this.createResourceRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Delete packaging resource
	 * Delete packaging resource
	 */
	async deleteResourceRaw(
		requestParameters: DeleteResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration/packaging/deleteResource`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: DeleteResourceRequestToJSON(requestParameters.deleteResourceRequest),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Delete packaging resource
	 * Delete packaging resource
	 */
	async deleteResource(
		requestParameters: DeleteResourceOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.deleteResourceRaw(requestParameters, initOverrides);
	}

	/**
	 * Enumerate packaging resources
	 * Enumerate packaging resources
	 */
	async enumerateResourcesRaw(
		requestParameters: EnumerateResourcesOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<Array<ResourceState>>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration/packaging/enumerateResources`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: EnumerateResourcesRequestToJSON(
					requestParameters.enumerateResourcesRequest
				),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			jsonValue.map(ResourceStateFromJSON)
		);
	}

	/**
	 * Enumerate packaging resources
	 * Enumerate packaging resources
	 */
	async enumerateResources(
		requestParameters: EnumerateResourcesOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<Array<ResourceState>> {
		const response = await this.enumerateResourcesRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Read package resource
	 * Read package resource
	 */
	async readResourceRaw(
		requestParameters: ReadResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ReadResourceResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration/packaging/readResource`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: ReadResourceRequestToJSON(requestParameters.readResourceRequest),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ReadResourceResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Read package resource
	 * Read package resource
	 */
	async readResource(
		requestParameters: ReadResourceOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ReadResourceResponse> {
		const response = await this.readResourceRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Restore packaging resource
	 * Restore packaging resource
	 */
	async restoreResourceRaw(
		requestParameters: RestoreResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<RestoreResourceResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration/packaging/restoreResource`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: RestoreResourceRequestToJSON(requestParameters.restoreResourceRequest),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			RestoreResourceResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Restore packaging resource
	 * Restore packaging resource
	 */
	async restoreResource(
		requestParameters: RestoreResourceOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<RestoreResourceResponse> {
		const response = await this.restoreResourceRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Update packaging resource
	 * Update packaging resource
	 */
	async updateResourceRaw(
		requestParameters: UpdateResourceOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<UpdateResourceResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration/packaging/updateResource`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateResourceRequestToJSON(requestParameters.updateResourceRequest),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			UpdateResourceResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Update packaging resource
	 * Update packaging resource
	 */
	async updateResource(
		requestParameters: UpdateResourceOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<UpdateResourceResponse> {
		const response = await this.updateResourceRaw(requestParameters, initOverrides);
		return await response.value();
	}
}
